import { siteStats, testimonials } from "@/mocks/site";

export default function Testimonials() {
  return (
    <section className="bg-background-50 border-b border-background-200">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl mb-10">
          <p className="text-xs tracking-[0.18em] text-primary-600 mb-2.5">读者口碑</p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">每天来看一眼的人，都是怎么说的</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <figure key={item.name} className="flex flex-col p-6 rounded-lg bg-background-100 border border-background-200">
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                <span className="w-11 h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img src={item.avatar} alt={`${item.name}的头像`} className="w-full h-full object-cover object-top" />
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-5">
          {siteStats.map((item) => (
            <div key={item.label} className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 shrink-0">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div>
                <p className="font-heading text-xl leading-none text-foreground-950">{item.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}